'use client'

import { AppLink } from '@/shared/lib/router'

import { useStoreStore } from '../stores/useStoreStore'

import type { RewardCategory } from '@/features/store/types/reward'
import { useStoreAnalytics } from '@/shared/lib/analytics'
import { Card, CardHeader, CardBody, CardTitle } from '@/shared/ui/Card'

export const StoreCategoriesList = () => {
  const { rewardCategories } = useStoreStore()
  const { trackStoreCategoryViewed } = useStoreAnalytics()

  const handleCategoryClick = (category: RewardCategory) => {
    trackStoreCategoryViewed(category)
  }

  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <Card>
        <CardHeader>
          <CardTitle>Lojinha</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
            {rewardCategories.map(category => (
              <AppLink
                key={category.id}
                href={`/loja/categorias/${category.id}`}
                className="flex flex-col items-center justify-center gap-2"
                onClick={() => handleCategoryClick(category)}
              >
                <div className="size-30 bg-gray-200 rounded-xl relative mt-6">
                  <img
                    src={category?.image?.file?.url || '/misc/pack.png'}
                    alt={category.name}
                    className="w-[105%] h-[calc(100%+20px)] object-contain object-bottom absolute bottom-0 left-1/2 -translate-x-1/2"
                  />
                </div>
                <span className="text-lg font-bold text-dark text-center">
                  {category.name}
                </span>
              </AppLink>
            ))}
          </div>
        </CardBody>
      </Card>
    </div>
  )
}
